import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import moment from "moment";
import constants from "@tracking/utils/constants";

const { DATETIME_FORMAT } = constants;

const parseGet = (data) => {
  return {
    dataHoraInicial: moment(data.dataHoraInicial).format(DATETIME_FORMAT.API),
    dataHoraFinal: moment(data.dataHoraFinal).format(DATETIME_FORMAT.API),
    status: data.status,
    ...data,
  };
};

export const getDataAcareacoes = createAsyncThunk(
  "acareacoesApp/acareacoes/getDataAcareacoes",
  async (params: object, { dispatch }) => {
    let response;
    try {
      response = await API.get("/entrega/contestacao/ativos", {
        params,
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return response.data;
  }
);

export const getVariableShowFilters = createAsyncThunk(
  "acareacoesApp/acareacoes/getVariableShowFilters",
  async () => {
    let response;
    try {
      response = await API.get("/variaveis?idCodigo=115");
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data?.items[0]?.valor?.toUpperCase() ?? "N";
  }
);

export const updateAcareacao = createAsyncThunk(
  "acareacoesApp/acareacoes/updateAcareacao",
  async (
    acareacao: {
      tipoUpdate: string;
      parsedData: { idReferenceNumber: string };
    },
    { dispatch, getState }
  ) => {
    const requestGetParams: any = getState();
    const { tipoUpdate, parsedData: data } = acareacao;
    let response;
    try {
      dispatch(
        openToast({
          severity: "info",
          title: "Iniciando transmissão",
        })
      );
      response = await API.patch(`/entrega/contestacao/${tipoUpdate}`, {
        ...data,
        nomeUsuario: requestGetParams.auth.info.name,
      });
      dispatch(
        openToast({
          severity: "success",
          title: "Transmissão finalizada",
        })
      );
      dispatch(
        getDataAcareacoes(
          parseGet(
            requestGetParams.acareacoesApp.acareacoes.dataAcareacoes
              .requestGetParams
          )
        )
      );
      return response.data;
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao transmitir",
          text: "Verifique se os dados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return response.data;
  }
);

export const updateBaixaAcareacao = createAsyncThunk(
  "acareacoesApp/acareacoes/updateBaixaAcareacao",
  async (
    data: { idReferenceNumber: string; novaDataHoraEntrega: string },
    { dispatch, getState }
  ) => {
    const requestGetParams: any = getState();
    let response;
    try {
      dispatch(
        openToast({
          severity: "info",
          title: "Iniciando transmissão",
        })
      );
      response = await API.patch(`/entrega/contestacao/indevida`, data);
      dispatch(
        openToast({
          severity: "success",
          title: "Transmissão finalizada",
        })
      );
      dispatch(
        getDataAcareacoes(
          parseGet(
            requestGetParams.acareacoesApp.acareacoes.dataAcareacoes
              .requestGetParams
          )
        )
      );
      return response.data;
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return response.data;
  }
);

export const updateExtravioAcareacao = createAsyncThunk(
  "acareacoesApp/acareacoes/updateExtravioAcareacao",
  async (data: { idReferenceNumber: string }, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    let response;
    try {
      dispatch(
        openToast({
          severity: "info",
          title: "Iniciando transmissão",
        })
      );
      response = await API.patch(`/entrega/contestacao/extravio`, data);
      dispatch(
        getDataAcareacoes(
          parseGet(
            requestGetParams.acareacoesApp.acareacoes.dataAcareacoes
              .requestGetParams
          )
        )
      );
      dispatch(
        openToast({
          severity: "success",
          title: "Transmissão finalizada",
        })
      );
      return response.data;
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return response.data;
  }
);

export const uploadComprovanteAcareacao = createAsyncThunk(
  "acareacoesApp/acareacoes/uploadComprovanteAcareacao",
  async (
    params: {
      idReferenceNumber: string;
      parsedData: object;
    },
    { dispatch, getState }
  ) => {
    const { idReferenceNumber, parsedData: data } = params;
    const requestGetParams: any = getState();

    try {
      dispatch(
        openToast({
          severity: "info",
          title: "Iniciando transmissão",
        })
      );
      await API.post(`/entrega/contestacao/comprovante`, data, {
        params: {
          referenceNumber: idReferenceNumber,
          nomeUsuario: requestGetParams.auth.info.name,
        },
      });
      dispatch(
        openToast({
          severity: "success",
          title: "Transmissão finalizada",
        })
      );
      dispatch(
        getDataAcareacoes(
          parseGet(
            requestGetParams.acareacoesApp.acareacoes.dataAcareacoes
              .requestGetParams
          )
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const viewComprovante = createAsyncThunk(
  "acareacoesApp/acareacoes/viewComprovante",
  async (identificadorEntregaFront: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await API.get(
        `/comprovante/pedido-online/${identificadorEntregaFront}`
      );
      return response.data?.attachments ?? [];
    } catch (err) {
      dispatch(
        openModalError({
          title: "Erro ao exibir dados",
          text: "Verifique se os dados digitados estão corretos!",
          btnLabel: "Voltar",
        })
      );
      return rejectWithValue(err.data);
    }
  }
);
